module.exports = __webpack_public_path__ + "img/help_content4.3b2a8b33.png";